// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__-yce4","col":"styles_col__1p61A"};